// Campus photo for /colleges/university-of-california-los-angeles: CC BY-SA 3.0, by Alton, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ARoyce_Hall_post_rain.jpg), checked 2026-09-30 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-california-los-angeles/; credited under the photo.
const photo = {
    "slug": "university-of-california-los-angeles",
    "alt": "Royce Hall on the UCLA campus in Los Angeles",
    "src": "/colleges/university-of-california-los-angeles/campus-1600.webp",
    "srcSmall": "/colleges/university-of-california-los-angeles/campus-800.webp",
    "srcMid": "/colleges/university-of-california-los-angeles/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-california-los-angeles/og.jpg",
    "title": "Royce Hall post rain",
    "author": "Alton",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ARoyce_Hall_post_rain.jpg",
    "read": "2026-09-30"
};

export default photo;
